import { useEffect } from 'react';
import PropTypes from 'prop-types';

const useValidateResourceType = (props) => {
  const { resourceType, typeFilters, router } = props;

  useEffect(() => {
    if (resourceType && typeFilters.length > 0) {
      const foundType = typeFilters.find(({ value }) => value === resourceType);
      if (!foundType) {
        const {
          location: { pathname, query },
        } = router;
        //Reset the Tabs to ALL
        router.replace({
          pathname,
          query: {
            ...query,
            type: '',
          },
        });
      }
    }
  }, [resourceType, typeFilters]);

  return [];
};

useValidateResourceType.propTypes = {
  resourceType: PropTypes.string.isRequired,
  typeFilters: PropTypes.array.isRequired,
  router: PropTypes.object.isRequired,
};

export default useValidateResourceType;
